export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const SET_PROFILES = 'SET_PROFILES'
export const SET_LOADING = 'SET_LOADING'
export const SET_LAST_FETCH = 'SET_LAST_FETCH'
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS'
export const SET_TEST_MODE = 'SET_TEST_MODE'
export const SET_QUOTATION_NOTIFICATIONS = 'SET_QUOTATION_NOTIFICATIONS'
export const SET_QUOTATION_LOADING = 'SET_QUOTATION_LOADING'
export const SET_LAST_QUOTATION_FETCH = 'SET_LAST_QUOTATION_FETCH'
